import React from 'react'
import { Box, Typography } from '@mui/material'
import Image from '../../../assets/images/about/market-researcher - Copy.jpg'

function FinalStatement() {
  return (
    <Box sx={{ width: '100%', pt: 10, pb: 1, bgcolor: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 5 }} >

            <Typography sx={{ width: '90%', textAlign: 'center', fontFamily: '"Montserrat", sans-serif', fontSize: '1.5rem' }} >
                At DataPi, we don’t just deliver research, we deliver clarity, strategy, and confidence. Whether you're scaling globally or evaluating market entry, we’re here to guide every step with precision.
            </Typography>
            <Typography sx={{ textAlign: 'center', fontFamily: '"Montserrat", sans-serif' }} >
                © {new Date().getFullYear()} DataPi. All rights reserved.
            </Typography>

    </Box>
  )
}

export default FinalStatement
